import clsx from "clsx";

export default function HowItWorksCard({
  headline,
  description,
  hasBgc,
}: {
  headline: string;
  description: string;
  hasBgc?: boolean
}) {
  return (
    <div className={clsx("flex flex-col flex-1 text-center py-8 pb-12 px-4", hasBgc ? 'bg-cloud' : "bg-white")} >
      <h1 className="whitespace-pre-wrap uppercase text-lg mt-2 lg:mt-4 font-semibold font-headline">{headline}</h1>
      <p className="mt-3 md:w-8/12 lg:w-5/6 md:mx-auto text-base">{description}</p>
    </div >
  );
}
